import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';
import { runRtkQuery } from '../helperFn';

export const terminalApi = createApi({
  reducerPath: 'terminalApi',
  baseQuery: baseQuery,
  tagTypes: ['terminalList'],
  endpoints: (builder) => ({
    addNewTerminal: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'addNewTerminal');
      },
      invalidatesTags: ['terminalList'],
    }),
    getTerminalList: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'getTerminalList');
      },
      providesTags: ['terminalList'],
    }),
    disableTerminal: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'disableTerminalDevice');
      },
    }),
    retireTerminal: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'retireTerminalDevice');
      },
    }),
    reissueTerminal: builder.mutation({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'reissueTerminalDevice');
      },
    }),
    getTerminalDevice: builder.query({
      query: (payload) => ({
        url: '/authrequest',
        method: 'POST',
        body: payload,
      }),
      async onQueryStarted(payload, { dispatch, queryFulfilled }) {
        await runRtkQuery(payload, dispatch, queryFulfilled, 'getTerminalDevice');
      },
    }),
  }),
});

export const {
  useAddNewTerminalMutation,
  useGetTerminalListQuery,
  useLazyGetTerminalListQuery,
  useDisableTerminalMutation,
  useRetireTerminalMutation,
  useReissueTerminalMutation,
  useLazyGetTerminalDeviceQuery,
} = terminalApi;
